import { StaticImageData } from 'next/image';
import nextArrowStepOneImage from 'public/images/next-arrow-step-one-image.svg';
import nextArrowStepThreeImage from 'public/images/next-arrow-step-three-image.svg';
import nextArrowStepTwoImage from 'public/images/next-arrow-step-two-image.svg';

import onBoardingStepOneImage from '/public/images/on-boarding/on-boarding-step-one-image.svg';
import onBoardingStepThreeImage from '/public/images/on-boarding/on-boarding-step-three-image.svg';
import onBoardingStepTwoImage from '/public/images/on-boarding/on-boarding-step-two-image.svg';
import { OnBoardingStep, Page } from '@/types/pages.types';
import { Severity, SeverityLevel } from '@/types/report.types';
import { buildTokenizedUrl } from '@/utils/url.utils';

export const HEADER_MARGIN_BOTTOM = 20;
export const HEADER_HEIGHT = 35;
export const MAIN_PADDING_TOP_AND_BOTTOM = 24;

export const mainImageMap: Record<string, StaticImageData> = {
  [OnBoardingStep.One]: onBoardingStepOneImage,
  [OnBoardingStep.Two]: onBoardingStepTwoImage,
  [OnBoardingStep.Three]: onBoardingStepThreeImage
};

export const distressSliderValueToColor: Record<number, string> = {
  0: '#80CB6E',
  1: '#80CB6E',
  2: '#80CB6E',
  3: '#80CB6E',
  4: '#F89636',
  5: '#F89636',
  6: '#F75F32',
  7: '#F75F32',
  8: '#E30000',
  9: '#E30000',
  10: '#781E0E'
};

export const onBoardingStepsToNumbers: Record<OnBoardingStep, number> = {
  [OnBoardingStep.One]: 1,
  [OnBoardingStep.Two]: 2,
  [OnBoardingStep.Three]: 3
};

export const onBoardingSteps: OnBoardingStep[] = [
  OnBoardingStep.One,
  OnBoardingStep.Two,
  OnBoardingStep.Three
];

export const nextOnBoardingStepNavigationMap: Record<OnBoardingStep, OnBoardingStep | Page.Login> =
  {
    [OnBoardingStep.One]: OnBoardingStep.Two,
    [OnBoardingStep.Two]: OnBoardingStep.Three,
    [OnBoardingStep.Three]: Page.Login
  };

export const nextArrowStepImageMap: Record<OnBoardingStep, StaticImageData | string> = {
  [OnBoardingStep.One]: nextArrowStepOneImage,
  [OnBoardingStep.Two]: nextArrowStepTwoImage,
  [OnBoardingStep.Three]: nextArrowStepThreeImage
};

export const onBoardingPreviousPagesMap = (token: string): Record<OnBoardingStep, string> => ({
  [OnBoardingStep.One]: '',
  [OnBoardingStep.Two]: buildTokenizedUrl(token, Page.OnBoarding, `step=${OnBoardingStep.One}`),
  [OnBoardingStep.Three]: buildTokenizedUrl(token, Page.OnBoarding, `step=${OnBoardingStep.Two}`)
});

export const severityLevelToNames: Record<SeverityLevel, Severity> = {
  [SeverityLevel.Mild]: Severity.Mild,
  [SeverityLevel.Moderate]: Severity.Moderate,
  [SeverityLevel.Severe]: Severity.Severe,
  [SeverityLevel.Worst]: Severity.Worst
};

export const datePickerFormat = 'MM/dd/yyyy';
export const dobRequestFormat = 'yyyy-MM-dd';
export const defaultLocale = 'en';
export const CALLBACK_REASON_INPUT_MAX_LENGTH = 1000;
